<template>
  <div class="ibox">
    <div class="ibox-title"><h5>管理员管理</h5></div>
    <div class="ibox-content">
    <div class="crud-bar">
      <el-button type="primary" icon="el-icon-plus" @click="openCreate">新建管理员</el-button>
    </div>
    <el-table :data="list" v-loading="loading" border stripe>
      <el-table-column prop="id" label="ID" width="70" />
      <el-table-column prop="login_name" label="登录名" />
      <el-table-column prop="display_name" label="显示名" />
      <el-table-column prop="status" label="状态" width="90">
        <template slot-scope="s">{{ s.row.status === 1 ? '启用' : '禁用' }}</template>
      </el-table-column>
      <el-table-column prop="createdAt" label="创建时间" />
      <el-table-column label="操作" width="160">
        <template slot-scope="s">
          <el-button size="mini" @click="openEdit(s.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="onDelete(s.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="420px">
      <el-form :model="form" label-width="80px">
        <el-form-item label="登录名">
          <el-input v-model="form.login_name" :disabled="!!form.id" />
        </el-form-item>
        <el-form-item label="显示名">
          <el-input v-model="form.display_name" />
        </el-form-item>
        <el-form-item :label="form.id ? '密码(留空不改)' : '密码'">
          <el-input v-model="form.password" type="password" placeholder="请输入密码" />
        </el-form-item>
        <el-form-item label="状态">
          <el-switch v-model="form.status" :active-value="1" :inactive-value="0" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="onSave">保存</el-button>
      </div>
    </el-dialog>
    </div>
  </div>
</template>

<script>
import { administratorsApi } from '../api/admin'

export default {
  name: 'AdminAdministrators',
  data () {
    return {
      list: [],
      loading: false,
      dialogVisible: false,
      saving: false,
      editing: null,
      form: { login_name: '', display_name: '', password: '', status: 1 }
    }
  },
  computed: {
    dialogTitle () {
      return this.editing ? '编辑管理员' : '新建管理员'
    }
  },
  created () {
    this.fetch()
  },
  methods: {
    async fetch () {
      this.loading = true
      try {
        this.list = await administratorsApi.list()
      } catch (e) {
        this.$message.error(e.uiMessage || e.message)
      } finally {
        this.loading = false
      }
    },
    openCreate () {
      this.editing = null
      this.form = { login_name: '', display_name: '', password: '', status: 1 }
      this.dialogVisible = true
    },
    openEdit (row) {
      this.editing = row
      this.form = { ...row, password: '' }
      this.dialogVisible = true
    },
    async onSave () {
      if (!this.form.login_name) return this.$message.warning('请填写登录名')
      this.saving = true
      const payload = { ...this.form }
      if (this.editing) {
        if (!payload.password) delete payload.password
        try {
          await administratorsApi.update(this.editing.id, payload)
          this.$message.success('已更新')
        } catch (e) { this.$message.error(e.uiMessage || e.message); return }
      } else {
        if (!payload.password) return this.$message.warning('请填写密码')
        try {
          await administratorsApi.create(payload)
          this.$message.success('已创建')
        } catch (e) { this.$message.error(e.uiMessage || e.message); return }
      }
      this.saving = false
      this.dialogVisible = false
      this.fetch()
    },
    async onDelete (row) {
      await this.$confirm(`确认删除管理员「${row.display_name || row.login_name}」？`, '提示', { type: 'warning' })
        .catch(() => false)
      if (!row) return
      try {
        await administratorsApi.remove(row.id)
        this.$message.success('已删除')
        this.fetch()
      } catch (e) { this.$message.error(e.uiMessage || e.message) }
    }
  }
}
</script>

<style scoped>
.crud-bar { margin-bottom: 16px; }
</style>
